import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";

/**
 * Finds blueprints whose names partially match the specified value.
 *
 * @param {BlueprintsArrayObjectTypes[]} availableBlueprintsArray - The array of available blueprints.
 * @param {string} value - The value to search for within blueprint names.
 * @returns {BlueprintsArrayObjectTypes[]} An array of blueprints whose names match the specified value.
 * Returns an empty array if the input value is empty or consists only of whitespace characters.
 */
export const findMatchingBlueprintsByName = (
  availableBlueprintsArray: BlueprintsArrayObjectTypes[],
  value: string,
): BlueprintsArrayObjectTypes[] => {
  const matchingBlueprints = [];
  const lowerCaseValue = value.toLowerCase();

  if (lowerCaseValue.trim() === "") {
    return matchingBlueprints;
  }

  availableBlueprintsArray.forEach((blueprint) => {
    const lowerCaseBlueprintName = blueprint.name.toLowerCase();

    if (lowerCaseBlueprintName.includes(lowerCaseValue)) {
      matchingBlueprints.push(blueprint);
    }
  });

  return matchingBlueprints;
};
